import { useState } from "react";
import { X, Plus } from "lucide-react";

export const DinnerPlayers = ({ players, setPlayers }) => {
  const [name, setName] = useState("");
  const add = (e) => {
    e.preventDefault();
    if (name.trim() && !players.includes(name.trim())) setPlayers([...players, name.trim()]);
    setName("");
  };
  return (
    <div data-testid="dinner-players">
      <p className="pp-label">Who's at the table?</p>
      <div className="flex flex-wrap gap-2 items-center">
        {players.map((p) => (
          <span key={p} className="pp-player" data-testid={`dinner-player-${p}`}>
            {p}
            <button onClick={() => setPlayers(players.filter((x) => x !== p))} aria-label={`Remove ${p}`}><X className="h-3.5 w-3.5" /></button>
          </span>
        ))}
        <form onSubmit={add} className="flex gap-2">
          <input className="pp-input pp-player-input" value={name} placeholder="Add a name" maxLength={20}
            onChange={(e) => setName(e.target.value)} data-testid="dinner-player-input" />
          <button className="pp-icon" aria-label="Add player" data-testid="dinner-add-player"><Plus className="h-4 w-4" /></button>
        </form>
      </div>
    </div>
  );
};
